// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3-caS","info":"PatientInfo_info__1f4If"};